import $ from 'jquery';
import transitionEnd from './transitionend';
import imageLoader from './imageLoader.js';

const isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

export default function() {
    const $mustheads = document.querySelectorAll('.masthead');

    $(".banner-place").on('init', function(){
        $('.banner-place').css({
            height: 'auto',
            visibility: 'visible'
        });
    });

    $(".banner-place").slick({
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        fade: true,
        dotsClass: 'masthead__paginator'
    });

    $mustheads.forEach(($musthead) => {
        const images = [];

        $musthead.querySelectorAll('.masthead__item').forEach((item, i) => {
            const $img = item.querySelector('img');
            if($img) {
                const pictureSrc = $img.getAttribute('data-picture');
                images.push({'imgElement': $img, 'src': pictureSrc, 'isFirst': i === 0});
            }
        });

        return images.reduce((promiseChain, image) => {
            return promiseChain.then(chainResults => {
                return new Promise(function(resolve, reject) {
                    imageLoader(image.src)
                        .then((src) => {
                            if(image.isFirst) {
                                const $clone = image.imgElement.cloneNode();
                                $clone.src = src;
                                $clone.classList.add('masthead__item__image--animated');

                                $clone.addEventListener(transitionEnd, function() {
                                    image.imgElement.parentNode.removeChild(image.imgElement);
                                    resolve(src);
                                })

                                image.imgElement.parentNode.insertBefore($clone, image.imgElement.nextSibling);

                                setTimeout(() => {
                                    $clone.classList.remove('masthead__item__image--animated');
                                }, 100);
                            }
                            else {
                                image.imgElement.src = src;
                                resolve(src);
                            }
                        })
                        .catch(() => {
                            reject();
                        });
                });
            });
        }, Promise.resolve([])).then(arrayOfResults => {
            $musthead.classList.remove('masthead--unload');
            $($musthead).slick({
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 3500,
                arrows: false,
                appendDots: $musthead,
                dots: true,
                dotsClass: 'masthead__paginator',
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                fade: !isTouch
            });
        });
    })
}
